export default {
  type: "Polygon",
  coordinates: [
    [
      [-118.261835050332, 33.777437],
      [-118.303509, 33.807035],
      [-118.374657, 33.873085],
      [-118.554398, 34.040271],
      [-118.626457, 34.165418],
      [-118.633667, 34.2391365],
      [-118.605583080272, 34.25471],
      [-118.474887692547, 34.310933],
      [-118.412715, 34.308476],
      [-118.288617, 34.248205],
      [-118.186774232934, 34.1388285],
      [-118.131438937102, 34.0152205],
      [-118.261835050332, 33.777437]
    ]
  ]
};
